import {
	configure,
	LocationPickerSheet,
	type LocationPickerSheetProps,
} from '@ixigo/cab-core/location';
import { getPwaLocation } from '../pwa/location';

configure({
	apiKey: import.meta.env.PUBLIC_MAP_KEY,
	locationProvider: getPwaLocation,
});

export type { LocationPickerSheetProps };
export { LocationPickerSheet };
